var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "subproject-item width-percent-100 h80 bg-white flex-start-center border-box ph12 yxtbizf-br-4",
    },
    [
      _c("yxtf-image", {
        staticClass: "subproject-img",
        attrs: { src: _vm.data.imageUrl, fit: "cover" },
      }),
      _c("div", { staticClass: "ml16 col-flex-1 over-hidden" }, [
        _c("h3", { staticClass: "font-size-16 c-26 ellipsis weight-400" }, [
          _vm._v(_vm._s(_vm.data.name)),
        ]),
        _vm.data.startTime && _vm.data.endTime
          ? _c("p", { staticClass: "mt9 text-8c font-size-11" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.formatTime(_vm.data.startTime)) +
                  " ~ " +
                  _vm._s(_vm.formatTime(_vm.data.endTime)) +
                  "\n    "
              ),
            ])
          : _c("p", { staticClass: "mt9 text-8c font-size-11" }, [
              _vm._v(_vm._s(_vm.$t("pc_biz_lbl_nolimittime" /* 不限时间 */))),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }